export default __webpack_public_path__ + "static/media/featured_tour_10.2936c339.png";